module.exports = __webpack_public_path__ + "img/Innovation-contest-works.9249c85b.png";